module.exports = __webpack_public_path__ + "img/English-Main-Menu-step-1.5b7f9ca3.png";